// Components==============
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import './CheckBox.module.scss';
// =========================

const CheckBox = ({ checked, onClick, children, blueGray }) => (
    <div onClick={onClick}>
        <label styleName={`wrapper ${blueGray ? 'blueGray' : ''}`}>
            <div styleName="checkbox">
                {checked && <FontAwesomeIcon icon={faCheck} />}
            </div>
            <p>{children}</p>
        </label>
    </div>
);

export default CheckBox;
